
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (window) {
    //TODO revisar si se conserva esta función vacía
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    window.console.log = function(): void {};
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  //TODO revisar si se conserva este console.error
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
